const focus = [
  'elonmusk',
  'mcuban',
  'jack',
  'ariannahuff',
  'biz',
  'levie',
  'ericschmidt',
  'garyvee',
  'ev',
  'tferriss',
  'sacca',
  'marissamayer',
  'kevinrose',
  'Veronica',
  'dickc',
  'karaswisher',
  'durov',
  'om',
  'paulg',
  'naval',
  'Benioff',
  'pmarca',
  'fredwilson',
  'Chad_Hurley',
  'anildash',
  'cdixon',
  'bhorowitz',
  'vkhosla',
  'swissmiss',
  'CathieDWood',
  'bgurley',
  'chamath',
  'randfish',
  'dhh',
  'johnmaeda',
  'Scobleizer',
  'APompliano',
  'lexfridman',
  'neilpatel',
  'brian_armstrong',
  'Jason',
  'alexisohanian',
  'davemcclure',
  'jess',
  'zeldman',
  'jasonsantamaria',
  'bfeld',
  'msuster',
  'khoi',
  'sorayadarabi',
  'benedictevans',
  'SusanWojcicki',
  'johndoerr',
  'jasonfried',
  'drewhouston',
  'briansolis',
  'dharmesh',
  'tristanwalker',
  'sherylsandberg',
  'tyler',
  'laura',
  'balajis',
  'arrington',
  'peterthiel',
  'hunterwalk',
  'hnshah',
  'mlevchin',
  'LukeW',
  'travisk',
  'pakman',
  'jaltucher',
  'patrickc',
  'MegWhitman',
  'rabois',
  'TaylorLorenz',
  'chr1sa',
  'mgsiegler',
  'sarah_edo',
  'andrewchen',
  'davidcohen',
  'benthompson',
  'JeffDean',
  'jeffjarvis',
  'alexia',
  'tobi',
  'tconrad',
  'MikeIsaac',
  'rrhoover',
  'shl',
  'TimDraper',
  'joshk',
  'david_perell',
  'kevinroose',
  'stewart',
  'ambermac',
  'laurashin',
  'DavidSacks',
  'justinkan',
  'sophiaamoruso',
  'RonConway',
  'scottbelsky',
  'kevin2kelly',
  'awilkinson',
  'HarryStebbings',
]

export default focus
